import { get } from 'lodash'

const status = {
  available: 'Disponível',
  scheduled: 'Agendado',
  canceled: 'Cancelado',
  absent: 'Ausente',
  present: 'Presente',
  attended: 'Atendida',
  in_attendance: 'Em atendimento'
}

export default (value) => get(status, value, value)



// WEBPACK FOOTER //
// ./src/helpers/scheduleStatus.js